import React from "react";
import { AiOutlineCopyrightCircle } from "react-icons/ai";
const Footer = () => {
  return (
    <div className="bg-[color:var(--main-blue)]  flex items-center flex-col justify-center text-white py-8 mt-8">
      <p className="text-center italic text-lg">
        We do not guarantee the information on this website.
      </p>
      <p className="flex items-center gap-2">
        <AiOutlineCopyrightCircle /> MyLlave LLC 2026
      </p>
    </div>
  );
};

export default Footer;
